// test278
(278 && 0);
